import React, { useContext } from 'react';
import { Context } from 'components/Store';
import { FormikTextArea } from 'components/UiKit/FormikFields';

const Notes = () => {
  const [{ isEnableInfoTabEdit }] = useContext(Context);

  return (
    <FormikTextArea
      id="notes"
      name="notes"
      className="overscroll-auto"
      style={{ height: '8rem' }}
      disabled={!isEnableInfoTabEdit}
      placeholder="Enter notes"
    />
  );
};

export default Notes;
